import { IAnalogSetpoint } from './types'
import { ListPanelWrapper } from '../../components/ListPaneWrapper';
import { useStyletron } from 'baseui';
import ValueInput from './ValueInput';

export function ListPanel(props: IAnalogSetpoint) {
    const [css, theme] = useStyletron();
    
    return (
        <ListPanelWrapper  {...props}>
            <div className={css({ width: '200px'})}>
            <ValueInput {...props} /> 
            </div>
        </ListPanelWrapper>
    );
}